import React from "react";
import { Route, Redirect } from "react-router-dom";

function ProtectedRoute({ auth: auth, component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (auth) {
          return <Component />;
        } else {
          return (
            <Redirect
              to={{ pathname: "/login", state: { from: props.location } }}
            />
          );
        }
      }}
    />
  );
}
export default ProtectedRoute;
